<template>
  <div class="top-content-wrap">
    <div class="landing-header-container">
      <div class="container">
        <div class="row center-xl">
          <div class="col-xs col-xl-10">
            <div class="header-claim">
              <div class="claim-title">
                <h1 class="bordered-heading headline_h1">
                  Auto bewerten - <br/> <span>Kostenlose Autobewertung auf PKW.de</span>
                </h1>
              </div>
              <ul class="row benefits-list">
                <li class="col-xs-12 col-lg-4 benefits-list_item">
                  <div class="image-wrapper">
                    <i class="fa fa-check"></i>
                    <img src="../assets/icons/benefits/benefit-1.svg" alt="Vom Sofa oder unterwegs">
                  </div>
                  <span class="text">Vom Sofa oder unterwegs</span>
                </li>
                <li class="col-xs-12 col-lg-4 benefits-list_item">
                  <div class="image-wrapper">
                    <i class="fa fa-check"></i>
                    <img src="../assets/icons/benefits/benefit-2.svg" alt="TÜV-Rheinland geprüfte Marktwertermittlung">
                  </div>
                  <span class="text">TÜV-Rheinland geprüfte <br /> Marktwertermittlung</span>
                </li>
                <li class="col-xs-12 col-lg-4 benefits-list_item">
                  <div class="image-wrapper">
                    <i class="fa fa-check"></i>
                    <img src="../assets/icons/benefits/benefit-3.svg" alt="Keine Registrierung erforderlich">
                  </div>
                  <span class="text">Keine Registrierung erforderlich</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ContentWidgetForm />
    <Vorteile />
    <section class="funktioniert-online-verkauf">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-lg-12">
            <h2 class="text-align headline_h2 bigger-title">
              Fahrzeugbewertung - kostenlos in drei Schritten
            </h2>
            <h3 class="text-align headline_h3 highlight bigger-description">
              So funktioniert es:
            </h3>
            <ul class="step-list landing">
              <li class="step">
                <div class="step-block">
                  <img
                    src="../assets/icons/landing-step-1.svg"
                    alt="Weitere Fahrzeugdaten, Zustand und Bilder erfassen"
                  />
                  <p class="text">
                    Du gibst Marke, Modell, Erstzulassung und weitere Fahrzeugdaten an
                  </p>
                </div>
              </li>
              <li class="step">
                <div class="step-block">
                  <img
                    src="../assets/icons/landing-step-2.svg"
                    alt="Bei Bedarf begutachtet ein TÜV Gutachter Ihr Fahrzeug direkt zu Hause"
                  />
                  <p class="text">
                    Unser TÜV-Rheinland zertifizierter Algorithmus ermittelt aus Millionen Datensätzen den Fahrzeugwert deines Autos
                  </p>
                </div>
              </li>
              <li class="step">
                <div class="step-block">
                  <img
                    src="../assets/icons/landing-step-3.svg"
                    alt="Mit Hilfe zertifizierter Autohändler, erzielen wir ein Höchstgebot für Ihr Fahrzeug"
                  />
                  <p class="text">
                    Du bekommst deinen Fahrzeugwert sofort angezeigt - ohne Registrierung
                  </p>
                </div>
              </li>
            </ul>

            <div class="action-block text-align">
              <button class="action-block__btn" @click="makeRedirect"><span class="text">Auto bewerten kostenlos</span> <i class="fas fa-arrow-right" /> </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { redirectToEvaluation } from "../services/helpers";
import ContentWidgetForm from "./ContentWidgetForm";
import Vorteile from './Vorteile.vue';

export default {
  name: "Header",
  data() {
    return {
      showModal: {
        garantie: false,
        days: false,
        lieferung: false,
        widget: false,
      },
    }
  },
  components: {
    ContentWidgetForm,
    Vorteile
  },
  methods: {
    openModal(modalId) {
      this.showModal[modalId] = true;
    },
    closeModal(modalId) {
      this.showModal[modalId] = false;
    },
    makeRedirect() {        
      redirectToEvaluation(this.$store);
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/vars";

a:hover {
  text-decoration: none !important;
}

body {
  font-family: "Asap", sans-serif !important;
}

// redesign code
.top-content-wrap,
.top-content-wrap * {
  font-family: "Asap", sans-serif;

  i {
    font-family: 'font awesome 5 free';
  }
}

hr {
  border: 0 none;
  background: $border-dark;
  height: 1px;
  width: 100%;
}

.top-content-wrap {
  // .inner-wrapper {
  //   max-width: 1620px;
  //   margin: 0 auto;
  //   height: 100%;
  //   padding: 40px 18px;
  // }

  .landing-header-container {
    background-image: url("../assets/bewerten-small-header-bg.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat ;
    position: relative;
    padding-top:35px;
    padding-bottom:35px;

    .container,
    .container div {
      position: static;
    }

    @media (max-width: 800px) {
      margin-top: 70px;
    }

    @include breakpoint(frommediumlarge) {
      background-image: url("../assets/bewerten-header-bg.jpg");
      padding-top:55px;
      padding-bottom:60px;

      &:before {
       display:none;
      }
    }

    @include breakpoint(fromgiant) {
      padding-top: 165px;
      padding-bottom: 229px;
      background-position: center center;

      
    }

    @media screen and (min-width:1200px) and (max-height:930px) {
      padding-top:45px;
      padding-bottom:195px;
    }

    @media screen and (min-width:1200px) and (max-height:950px) {
      padding-bottom:180px;
    }

    @include breakpoint(extralarge) {
      background-position: center;
    }

    .header-claim {
      .claim-title {
        @media (max-width: 800px) {
          position: absolute;
          top: 0;
          left: 0;
          width: 100vw;
          background: black;
          text-align: center;
          padding: 10px;
          top: -70px;

          &:after {
            content: "";
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 22px 50vw 0 50vw;
            border-color: #000 transparent transparent transparent;
          }
        }

        @include breakpoint(frommediumlarge) {
          margin-bottom: 34px;
        }
        @include breakpoint(extralarge) {
          margin-bottom: 40px;
          margin-top: 75px;
        }

        @media screen and (min-width:1200px) and (max-height:950px) {
          h1 {
            font-size:50px !important;
            line-height:60px !important;
          }
        }

        h1 {
          color: $white;
          padding-left: 40px;
          text-align: initial;
          &:before {
            background: $white;
          }
          @media (max-width: 800px) {
            text-align: center;
            padding-left: 0;
            margin-bottom: 0;

            &:before {
              display: none;
            }

            span {
              font-size: 16px;
            }
          }
        }

        span {
          display:block;
          font-size:20px;
          line-height:28px;

          @include breakpoint(frommediumlarge) {
            font-size:32px;
            line-height:40px;
          }

          @include breakpoint(fromgiant) {
            font-size:50px;
            line-height:70px;
          }

          @include breakpoint(extralarge) {
            font-size:60px;
            line-height:69px;
          }

          @media screen and (min-width:1200px) and (max-height:950px) {
            font-size:32px;
            line-height:40px;
          }
        }
      }

      .benefits-list {
        padding-top: 20px;

        @include breakpoint(fromlarge) {
          padding-top:0;
        }
        &_item {
          display: flex;
          gap: 20px;
          align-items: center;
          padding-left: 0;
          margin-bottom:10px;

          @include breakpoint(fromlarge) {
            margin-bottom:0;
          }

          .image-wrapper {
            @include breakpoint(fromlarge) {
              min-width: 80px;
              min-height: 80px;
            }

            i {
              color: $red;
              @include breakpoint(fromlarge) {
                display: none;
              }
            }

            img {
              display: none;
              @include breakpoint(fromlarge) {
                display: initial;
                width: 100%;
              }
            }
          }

          span {
            color: $white;
            font-weight: bold;
            text-align: left;
          }
        }
      }
      .claim-content {
        ul {
          padding-left: 0;

          li {
            font-weight: 600;
            font-size: 15px;
            line-height: 22px;
            padding-left: 23px;
            position: relative;
            margin-bottom: 8px;

            @include breakpoint(frommediumlarge) {
              font-size: 24px;
              line-height: 31px;
              padding-left: 36px;
              margin-bottom: 17px;
            }

            @include breakpoint(fromgiant) {
              font-size: 24px;
              line-height: 31px;

              br {
                display: none;
              }
            }

            @media screen and (min-width:1200px) and (max-height:950px) {
                font-size:20px;
                line-height:24px;
              }

            &:before {
              content: "";
              display: block;
              width: 14px;
              height: 11px;
              background-size: cover;
              background-position: center;
              background-image: url("../assets/check.svg");
              position: absolute;
              left: 0;
              top: 8px;

              @include breakpoint(frommediumlarge) {
                width: 24px;
                height: 19px;
              }
            }
          }
        }
      }
    }
  }

  section.online-verkaufen-fahrzeugwert {
    padding-top:20px;
    padding-bottom: 30px;

    @include breakpoint(frommediumlarge) {
      padding-top: 36px;
      padding-bottom: 60px;
    }

    @include breakpoint(fromgiant) {
      padding-top: 76px;
      padding-bottom: 110px;
    }

    h2 {
      br {
        display:none;
        @include breakpoint(fromlarge) {
          display:block;
        }
      }
    }
  }

  .teaser-wrap-row {
    padding-top: 10px;

    @include breakpoint(frommediumlarge) {
      padding-top:23px;
    }

    @include breakpoint(fromgiant) {
      padding-top: 35px;
      padding-bottom: 55px;
    }

    .teaser-block {
      margin-bottom:23px;
      @include breakpoint(frommediumlarge) {
         margin-bottom:55px;

         &:last-of-type {
           margin-bottom:43px;
         }
      }
      @include breakpoint(fromgiant) {
         margin-bottom:0;

         &:last-of-type {
           margin-bottom:0;
         }
      }
      br {
        display:none;
        @include breakpoint(frommediumlarge) {
          
          &:nth-of-type(2) {
            display:none;
          }
        }
        @include  breakpoint(extralarge) {
          display:block;
        }
      }

      .icon-block {
        margin-bottom: 13px;

        @include breakpoint(frommediumlarge) {
            margin-bottom:30px;
        }

        img {
          height:76px;

          @include breakpoint(frommediumlarge) {
            height:auto;
          }
        }
      }
      .teaser-title {
        
        @include breakpoint(frommediumlarge) {
          padding-bottom: 12px;
        }
      }
    }
  }

  .funktioniert-online-verkauf {
    padding-top: 25px;

    @include breakpoint(fromgiant) {
      display:block;
      padding-top:0;
    }

    .bigger-title {
      @include breakpoint(extralarge) {
        font-size: 50px;
        line-height: 30px;
      }
    }

    .bigger-description {
      @include breakpoint(extralarge) {
        font-size: 40px;
        line-height: 26px;
        margin-top: 30px;
      }
    }
    .action-block {
      padding-top:20px;
      margin-bottom:35px;

      &__btn i {
        padding-left: 10px;
      }

      @include breakpoint(frommediumlarge) {
        padding-top: 0;
        margin-bottom: 50px;
      }
      @include breakpoint(fromgiant) {
        padding-top: 75px;
        margin-bottom: 80px;
      }
    }

    .red-subtitle {
      color: #C0141B;
    }
  }

  ul.step-list.landing {
    padding: 15px 0 0;
    width: 100%;

    @include breakpoint(fromlarge) {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    @include breakpoint(fromgiant) {
      padding: 45px 0 0;
    }

    @include breakpoint(extralarge) {
      padding: 55px 50px 0;
    }

    li {
      
      width:100%;
      position:relative;

      @include breakpoint(fromlarge) {
        width:20%;
        text-align: center;
      }

      .step-block {
        display:flex;
        align-items: center;
        margin-bottom:20px;

        @include breakpoint(frommediumlarge) {
          margin-bottom:40px;
        }

        @include breakpoint(fromlarge) {
          display:block;
          padding:0 10px;
        }

        @include breakpoint(fromgiant) {
          margin-bottom:0;
        }

        @include breakpoint(full) {
          padding:0;
        }

        br {
          display:none;
          @include breakpoint(full) {
            display:block;
          }
        }

        img {
          width:75px;
          margin-right:22px;

          @include breakpoint(fromlarge) {
            margin-right:0;
          }

          @include breakpoint(fromgiant) {
            width:auto;
            
          }
        }

        p {
          margin-bottom:0;
          @include breakpoint(fromlarge) {
            font-size:16px;
          }

          @include breakpoint(full) {
            font-size: 18px;
            
          }
        }
      }

      &:last-of-type {
        &:after {
          display:none;
        }
      }
      
      @include breakpoint(fromlarge) {
        &:after {
          content:"";
          display:block;
          height: 3px;
          background: $dark-light;
          width: 150px;
          position:absolute;
          left: 100%;
          transform: translateX(50%);
          top:40px;
        }
      }

      @include breakpoint(fromgiant) {
        &:after {
          top:63px;
        }
      }
      img {       

        @include breakpoint(fromgiant) {
          margin-bottom: 26px;
        }
      }
    }
  }

  .contact-container {
    background:$light-gray;
    border-radius: 12px;
    margin-top: 35px;

    @include breakpoint(frommediumlarge) {
      margin-top: 55px;
    }

    @include breakpoint(fromgiant) {
      background:transparent;
      border-radius:0;
      margin-top:0;
    }
  }

  .contact-block {
    background: $light-gray;
    border-radius: 12px;
    padding: 26px 0 34px;
    text-align:center;

    @include breakpoint(frommediumlarge) {
      padding:50px 0 62px;
    }

    @include breakpoint(fromgiant) {
      padding: 50px 0;
      margin-top: 75px;
      padding: 50px 30px;
      text-align:left;
    }

    @include breakpoint(extralarge) {
      padding: 50px 60px;
    }

    @include breakpoint(full) {
      padding: 50px 135px;
    }

    .inner-wrap {    

      @include breakpoint(fromgiant) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      p {
        margin-bottom: 0;
        font-size: 20px;
        line-height: 30px;

        @include breakpoint(fromgiant) {
          font-size: 24px;
          line-height: 32px;
        }

         @include breakpoint(extralarge) {
          font-size: 30px;
          line-height: 50px;
        }

        strong {
          display:block;

          @include breakpoint(frommediumlarge) {
            display:inline;
          }
        }
      }

      .action-block {
        padding-top:20px;
        text-align:center;
        flex-direction: column;
        display:flex;
        align-items: center;
        .btn:first-of-type {
          margin-bottom:25px;

          @include breakpoint(frommediumlarge) {
            margin-right: 47px;
            margin-bottom:0;
          }
        }

        @include breakpoint(frommediumlarge) {
          text-align:left;
          justify-content: center;
          flex-direction: row;
        }

        @include breakpoint(fromgiant) {
          padding-top:0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/landing-components/Header.vue